"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { ArrowRight } from "lucide-react";

export default function StickyCtaMobile({ startHref = "/start" }: { startHref?: string }) {
  const [heroCtaHidden, setHeroCtaHidden] = useState(false);
  const [footerVisible, setFooterVisible] = useState(false);

  useEffect(() => {
    const heroCta = document.getElementById("hero-cta");
    const footer = document.getElementById("top-footer");

    const heroObserver = new IntersectionObserver(
      ([entry]) => setHeroCtaHidden(!entry.isIntersecting),
      { threshold: 0 }
    );

    const footerObserver = new IntersectionObserver(
      ([entry]) => setFooterVisible(entry.isIntersecting),
      { threshold: 0 }
    );

    if (heroCta) heroObserver.observe(heroCta);
    if (footer) footerObserver.observe(footer);

    return () => {
      heroObserver.disconnect();
      footerObserver.disconnect();
    };
  }, []);

  const visible = heroCtaHidden && !footerVisible;

  return (
    <div
      aria-hidden={!visible}
      className={`fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-outline-variant shadow-[0_-4px_12px_rgba(0,0,0,0.08)] px-4 py-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <Link
        href={startHref}
        tabIndex={visible ? 0 : -1}
        className="flex items-center justify-center gap-2 w-full bg-accent text-white py-3.5 rounded-xl font-extrabold text-base hover:bg-accent-hover transition-colors shadow-[0_4px_12px_rgba(246,122,80,0.25)]"
      >
        無料で試してみる
        <ArrowRight className="w-5 h-5" />
      </Link>
    </div>
  );
}
